import { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { INTRO_ANIMATION } from '../../page/components/HeroSection/constants';

export function useHeroAnimation() {
    const wordRefs = useRef<(HTMLElement | null)[]>([]);

    useGSAP(() => {
        const words = wordRefs.current.filter(Boolean);
        const { delay, headline } = INTRO_ANIMATION;

        gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', () => {
            gsap.timeline({ delay }).fromTo(
                words,
                { rotateX: 90, transformOrigin: '50% 50%', transformPerspective: 600 },
                { rotateX: 0, stagger: headline.stagger, duration: headline.duration, ease: headline.ease }
            );
        });
    }, []);

    return { wordRefs };
}
